var _rect, _text, _text2, _g, _g2, _g3, _g4, _line, _text3, _text4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCase3AFig5SettleabilityBySourceType(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 830 460",
    fontFamily: "Geist, 'Segoe UI', -apple-system, sans-serif",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 830,
    height: 460,
    fill: "#FFFDF7"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 48,
    y: 52,
    fontSize: 22,
    fontWeight: 600,
    fill: "#1A2F2A"
  }, "Automatically checkable yield, by source type")), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 48,
    y: 76,
    fontSize: 14,
    fill: "#4A5F56"
  }, "Share of mined units whose acceptance settles with no human judgment")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "#EEF2EF",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("line", {
    x1: 260,
    y1: 120,
    x2: 260,
    y2: 330
  }), /*#__PURE__*/React.createElement("line", {
    x1: 406.7,
    y1: 120,
    x2: 406.7,
    y2: 330
  }), /*#__PURE__*/React.createElement("line", {
    x1: 553.3,
    y1: 120,
    x2: 553.3,
    y2: 330
  }), /*#__PURE__*/React.createElement("line", {
    x1: 700,
    y1: 120,
    x2: 700,
    y2: 330
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    fontSize: 12,
    fill: "#8A9A90",
    textAnchor: "middle"
  }, /*#__PURE__*/React.createElement("text", {
    x: 260,
    y: 352
  }, "0%"), /*#__PURE__*/React.createElement("text", {
    x: 406.7,
    y: 352
  }, "10%"), /*#__PURE__*/React.createElement("text", {
    x: 553.3,
    y: 352
  }, "20%"), /*#__PURE__*/React.createElement("text", {
    x: 700,
    y: 352
  }, "30%"))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("text", {
    x: 244,
    y: 176,
    fontSize: 14,
    fill: "#1A2F2A",
    textAnchor: "end"
  }, "Academic and method"), /*#__PURE__*/React.createElement("text", {
    x: 244,
    y: 194,
    fontSize: 12,
    fill: "#6B7F74",
    textAnchor: "end"
  }, "2 sources, 88 units"), /*#__PURE__*/React.createElement("rect", {
    x: 260,
    y: 152,
    width: 396,
    height: 44,
    rx: 4,
    fill: "#16A34A"
  }), /*#__PURE__*/React.createElement("text", {
    x: 668,
    y: 180,
    fontSize: 15,
    fontWeight: 600,
    fill: "#1A2F2A"
  }, "27% (24 of 88)"))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("text", {
    x: 244,
    y: 266,
    fontSize: 14,
    fill: "#1A2F2A",
    textAnchor: "end"
  }, "Industry writing"), /*#__PURE__*/React.createElement("text", {
    x: 244,
    y: 284,
    fontSize: 12,
    fill: "#6B7F74",
    textAnchor: "end"
  }, "7 sources, 199 units"), /*#__PURE__*/React.createElement("rect", {
    x: 260,
    y: 242,
    width: 29,
    height: 44,
    rx: 4,
    fill: "#6366F1"
  }), /*#__PURE__*/React.createElement("text", {
    x: 301,
    y: 270,
    fontSize: 15,
    fontWeight: 600,
    fill: "#1A2F2A"
  }, "2% (4 of 199)"))), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 260,
    y1: 330,
    x2: 700,
    y2: 330,
    stroke: "#D4DDD6",
    strokeWidth: 1.5
  })), _text3 || (_text3 = /*#__PURE__*/React.createElement("text", {
    x: 48,
    y: 418,
    fontSize: 13,
    fill: "#6B7F74"
  }, "A 2009 behavioural-biology paper about definitional consensus supplied 20 of the run's 28")), _text4 || (_text4 = /*#__PURE__*/React.createElement("text", {
    x: 48,
    y: 436,
    fontSize: 13,
    fill: "#6B7F74"
  }, "machine-checkable candidates; the seven agent-orchestration sources supplied 4 between them.")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCase3AFig5SettleabilityBySourceType);
export default __webpack_public_path__ + "static/media/case3a-fig5-settleability-by-source-type.b68ed36832efefbd5772d11a70d506eb.svg";
export { ForwardRef as ReactComponent };